"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouter = require("react-router");

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _MiniListing = _interopRequireDefault(require("../shared/MiniListing"));

var _trackClick = _interopRequireDefault(require("../HOCs/trackClick"));

var _utils = require("../utils");

var _Arrow = _interopRequireDefault(require("./Arrow"));

var _withAppContext = require("../HOCs/withAppContext");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AppCategory =
/*#__PURE__*/
function (_Component) {
  _inherits(AppCategory, _Component);

  function AppCategory(props) {
    var _this;

    _classCallCheck(this, AppCategory);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AppCategory).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "renderListings", function () {
      var sliderFeaturesVisibility = _this.getSliderVisibility();

      var variableMargins = sliderFeaturesVisibility ? '' : 'no-side-margins';
      var sliderSettings = {
        dots: true,
        infinite: false,
        speed: 500,
        lazyLoad: false,
        responsive: [{
          breakpoint: 530,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }, {
          breakpoint: 980,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        }, {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5
          }
        }, {
          breakpoint: 10000,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 6
          }
        }],
        className: "slider-row ".concat(variableMargins),
        dotsClass: "".concat(sliderFeaturesVisibility ? 'ac-listings-slider-dots' : 'hidden'),
        draggable: true
      };
      return _react.default.createElement("div", {
        className: "collection-row"
      }, _react.default.createElement(_reactSlick.default, sliderSettings, _this.props.listings.map(function (listing, i) {
        var TrackedListing = (0, _trackClick.default)(_react.default.createElement(_MiniListing.default, {
          listing: listing,
          isLoggedIn: _this.props.isLoggedIn
        }), 'CLICK', {
          context: 'HOME',
          type: 'LISTING',
          v2_listing_id: listing.ID,
          app_name: listing.core.listingName,
          domain: window.location.hostname
        });
        var listingLink = "".concat((0, _utils.getAppCenterPathName)(_this.props.location.pathname), "/listings/").concat(listing.ID);
        return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactRouter.Link, {
          key: i,
          to: listingLink,
          "data-analytics": "ec=".concat(listing.localized.name, "\n                |ea=ViewDetails\n                |dp=Home\n                |dt=AppCenterHome\n                |cd2=nui"),
          onClick: function onClick() {
            return document.title = _this.props.context.getTitle(listing.localized.name);
          }
        }, _react.default.createElement(TrackedListing, {
          style: {
            display: 'inline-block'
          }
        })));
      })));
    });

    _this.state = {
      width: 0,
      height: 0
    };
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AppCategory, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: "updateWindowDimensions",
    value: function updateWindowDimensions() {
      this.setState({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
  }, {
    key: "getSliderVisibility",
    value: function getSliderVisibility() {
      var sliderFeaturesVisibility = false;

      if (this.props.listings.length > 6 && this.state.width > 1200) {
        sliderFeaturesVisibility = true;
      } else if (this.props.listings.length > 5 && this.state.width > 980 && this.state.width <= 1200) {
        sliderFeaturesVisibility = true;
      } else if (this.props.listings.length > 4 && this.state.width > 768 && this.state.width <= 980) {
        sliderFeaturesVisibility = true;
      } else if (this.props.listings.length > 2 && this.state.width <= 768) {
        sliderFeaturesVisibility = true;
      }

      return sliderFeaturesVisibility;
    }
  }, {
    key: "renderArrow",
    value: function renderArrow(prevNext, isVisible) {
      return _react.default.createElement(_Arrow.default, {
        direction: prevNext,
        areSlideFeaturesVisible: isVisible ? '' : 'hidden'
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.listings.length === 0) return null;
      return _react.default.createElement("div", null, _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-sm-12"
      }, _react.default.createElement("h2", {
        className: "collection-title"
      }, this.props.categoryTitle), _react.default.createElement("p", {
        className: "collection-description"
      }, this.props.categorySubtitle))), this.renderListings());
    }
  }]);

  return AppCategory;
}(_react.Component);

AppCategory.propTypes = {
  categoryTitle: _propTypes.default.any.isRequired,
  categorySubtitle: _propTypes.default.any.isRequired,
  listings: _propTypes.default.array.isRequired,
  isLoggedIn: _propTypes.default.bool.isRequired,
  location: _propTypes.default.object
};

var _default = (0, _withAppContext.withAppContext)((0, _reactRouter.withRouter)(AppCategory));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/listings/AppCategory.js
// module id = 247
// module chunks = 0